import React from 'react';
import logo from '../../Logo-sustain.png';

const Header = ({
  userEmail,
  onLogout
}) => {
  return (
    <header className="bg-white shadow-lg border-b border-green-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:justify-between md:items-center py-4 gap-4">
          <div className="flex items-center space-x-3 md:space-x-4">
            <div className="p-1">
              <img src={logo} alt="sustAId Logo" className="w-16 h-16 md:w-20 md:h-20 object-contain" />
            </div>
            <div>
              <h1 className="text-xl md:text-3xl font-bold text-gray-900">
                sust<span style={{ color: '#16a34a', fontStyle: 'italic', fontSize: '1.2em' }} className="font-extrabold">AI</span>d
              </h1>
              <p className="text-xs md:text-base text-gray-600 hidden sm:block">AI-Powered Sustainable Material Selection</p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-4">
            {userEmail && onLogout && (
              <div className="flex items-center justify-between sm:justify-start gap-2 sm:gap-3">
                <div className="flex items-center space-x-2 bg-green-50 text-green-800 px-3 py-2 rounded-lg text-xs sm:text-sm font-medium">
                  <span className="inline-block w-2 h-2 bg-green-600 rounded-full"></span>
                  <span className="truncate max-w-[180px] sm:max-w-[220px]">{userEmail}</span>
                </div>
                <button
                  onClick={onLogout}
                  className="px-3 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-xs sm:text-sm font-semibold"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
